import { Text } from 'tamagui'
import { BellOff, Bell, Check, Settings, LogOut } from '@tamagui/lucide-icons'
import { ContextMenu, type ContextMenuSection } from '../../common'
import { useAppStore, useServerStore } from '@/store'

interface ServerContextMenuProps {
  serverId: string
  x: number
  y: number
  onClose: () => void
}

export function ServerContextMenu({ serverId, x, y, onClose }: ServerContextMenuProps) {
  const { mutedServerIds, toggleMuteServer, navigateToServerSettings } = useAppStore()
  const { removeServer } = useServerStore()
  const isMuted = mutedServerIds.includes(serverId)

  const sections: ContextMenuSection[] = [
    {
      items: [
        {
          id: 'mark-read',
          label: 'Mark as Read',
          icon: <Check size={14} color="$sidebarMuted" />,
          action: () => {},
        },
        {
          id: 'mute',
          label: isMuted ? 'Unmute Server' : 'Mute Server',
          icon: isMuted
            ? <Bell size={14} color="$sidebarMuted" />
            : <BellOff size={14} color="$sidebarMuted" />,
          action: () => toggleMuteServer(serverId),
        },
      ],
    },
    {
      items: [
        {
          id: 'settings',
          label: 'Server Settings',
          icon: <Settings size={14} color="$sidebarMuted" />,
          action: () => navigateToServerSettings(serverId),
        },
      ],
    },
    {
      items: [
        {
          id: 'leave',
          label: 'Leave Server',
          icon: <LogOut size={14} color="$error" />,
          danger: true,
          action: () => removeServer(serverId),
        },
      ],
    },
  ]

  return <ContextMenu x={x} y={y} sections={sections} onClose={onClose} />
}
